import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { RETURN_PATH_KEY, useAuth } from '../contexts/authContext';
/**
 * ProtectedRoute component that redirects to login if user is not authenticated
 * Saves current path so the user is returned after login
 */ export function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();
    if (isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-screen items-center justify-center bg-background",
            children: /*#__PURE__*/ _jsx("div", {
                className: "text-center",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "text-muted-foreground",
                    children: "Loading..."
                })
            })
        });
    }
    if (!isAuthenticated) {
        const currentPath = location.pathname + location.search + location.hash;
        if (currentPath && currentPath !== '/') {
            sessionStorage.setItem(RETURN_PATH_KEY, currentPath);
        }
        return /*#__PURE__*/ _jsx(Navigate, {
            to: "/login",
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
